"use strict";
const songs = ["", "narrateur-intro.mp3", "narrateur-1.mp3", "01.mp3","narrateur-2.mp3", "02.mp3", "narrateur-3.mp3", "","narrateur-4.mp3", "", "", "narrateur-5.mp3", "narrateur-6.mp3", "03.mp3", "", "04.mp3", "", "narrateur-7.mp3", "", "narrateur-8.mp3", "05.mp3", "narrateur-9.mp3", "", "", "narrateur-10.mp3", "06.mp3", "narrateur-11.mp3", "07.mp3", "narrateur-12.mp3", "08.mp3"];
let songIndex = 0;
const music=document.querySelector(".lecteur");

const loadSong = (songs) => {
    music.src = "assets/sound/"+songs;
}



// App Changement de dialogue
const btnPrev = document.querySelector('.slider__btn--prev'),
      btnNext = document.querySelector('.slider__btn--next');

btnNext.addEventListener('click', next);	
btnPrev.addEventListener('click', prev);

function next(){
	let elShow = document.querySelector('.slider__el--show'),
        elNext = elShow.nextElementSibling;
    
    elShow.classList.remove('slider__el--show');
    let wheel = document.querySelector('.season__wheel')
    let arrow = document.querySelector('.container__imgarrow')
    if(elNext.classList.contains('background--ete')){
        arrow.classList.add('arrow--ete')
    }
    if(elNext.classList.contains('background--automne')){
        arrow.classList.add('arrow--automne')
        arrow.classList.remove('arrow--ete')
    }
    if(elNext.classList.contains('background--hiver')){
        arrow.classList.add('arrow--hiver')
        arrow.classList.remove('arrow--automne')
    }
    if(elNext.classList.contains('background--moineau')){
        arrow.classList.add('arrow--primtemps')
        arrow.classList.remove('arrow--hiver')
    }
    if(elNext.dataset.wheel == 'true'){    
        if(wheel.classList.contains('.season__wheel--show')==false){
             wheel.classList.add('season__wheel--show')
        } 
    }else if(elNext.dataset.wheel == 'false'){
        
        wheel.classList.remove('season__wheel--show')
   } 
    

    

    songIndex = songIndex + 1;
    loadSong(songs[songIndex]);
    music.play();
    
    if(btnNext.classList.contains('hidden')){
        btnNext.classList.remove('hidden');
        btnPrev.classList.remove('hidden');
    }
    if(elNext.classList.contains('btn-hidden')){
        btnPrev.classList.add('hidden');
    }
	if(elNext){
        elNext.classList.add('slider__el--show');
        if(elNext.classList.contains('next-hidden')){
            btnNext.classList.add('btn--hidden');
        }else{
            btnNext.classList.remove('btn--hidden');    
        }
    }
    if(elNext.classList.contains('last')){
        btnNext.classList.add('btn--hidden');
    }

    // dialogues
    if(elNext.classList.contains('div-dia-0')){
        diaAnim();
    }else if(elNext.classList.contains('div-dia-1')){
        diaAnim1();
    }else if(elNext.classList.contains('div-dia-2')){
        diaAnim2();
    }else if(elNext.classList.contains('div-dia-3')){
        diaAnim3();
    }else if(elNext.classList.contains('div-dia-4')){
        diaAnim4();
    }else if(elNext.classList.contains('div-dia-5')){
        diaAnim5();
    }
}

function prev(){
   let elShow = document.querySelector('.slider__el--show'),
      elPrev = elShow.previousElementSibling;
   elShow.classList.remove('slider__el--show');

   songIndex = songIndex - 1;
   loadSong(songs[songIndex]);
   music.play();

    if(elPrev.classList.contains('btn-hidden')){
        btnPrev.classList.add('hidden');
    }

   if(elPrev){
      elPrev.classList.add('slider__el--show');
      if(elPrev.classList.contains('next-hidden')){
        btnNext.classList.add('btn--hidden');
      }else{
        btnNext.classList.remove('btn--hidden');    
      }
    }

}
const btnGo = document.querySelectorAll('.slider__btn--go');
for(let btnGoEl of btnGo){
    btnGoEl.addEventListener('click',(e) =>{
        next();  
    });  
}
//Phaser Games

console.log(Phaser.VERSION)
        

let config = {
   type: Phaser.AUTO,
   width:960,
   height:600, 
   transparent: true,
   physics:{
       default: 'arcade',
       arcade: {
           gravity: {y:0},
           debug: false
       }
   }
}
let game = new Phaser.Game(config)


/////////////////// EATGAME///////////////////////////

var EatGame = new Phaser.Class({
   Extends: Phaser.Scene,
   initialize: function EatGame(config) {
       Phaser.Scene.call(this, config);
     },
   
   preload: function()
   {
       this.load.image('gorge', 'assets/images/rougegorge.png');
       this.load.image('chocolat', 'assets/images/chocolat.png');
       this.load.image('seed', 'assets/images/seed.png');
       this.load.image('fruits', 'assets/images/fruits.png');
       this.load.image('insect', 'assets/images/insect.png');
       this.load.image('honey', 'assets/images/honey.png');
       this.load.image('branche','assets/images/branche.png')
   },
   create: function()
   {   

       this.branche = this.add.image(100,620,'branche')
       this.branche.setScale(0.9) 
       this.branche.flipX = true;
       this.gorge = this.add.image(100,450,'gorge')
       this.gorge.setScale(0.5) 
       this.physics.add.existing(this.gorge)
       this.gorge.flipX = true;
       let gorge = this.gorge;
       this.chocolat = this.add.image(550,150,'chocolat')
       this.chocolat.setScale(0.2) 
       this.physics.add.existing(this.chocolat)
       this.seed = this.add.image(700,150,'seed')
       this.seed.setScale(0.2) 
       this.physics.add.existing(this.seed)
       this.fruits = this.add.image(500,300,'fruits')
       this.fruits.setScale(0.2) 
       this.physics.add.existing(this.fruits)
       this.insect = this.add.image(750,300,'insect')
       this.insect.setScale(0.2) 
       this.physics.add.existing(this.insect)
       this.honey = this.add.image(625,450,'honey')
       this.honey.setScale(0.2) 
       this.physics.add.existing(this.honey)
       
       
       
       let foodscore = 0

       let chocolat =  this.chocolat
       let seed =  this.seed
       let fruits =  this.fruits
       let insect =  this.insect
       let honey =  this.honey

       this.chocolat.setInteractive({ draggable: true })
               this.chocolat.on('dragstart', function(pointer, dragX, dragY){
                   // ...
               })
               this.chocolat.on('drag', function(pointer, dragX, dragY){
                   chocolat.setPosition(dragX, dragY);
                   
               })
               this.chocolat.on('dragend', function(pointer, dragX, dragY, dropped){
                   if(chocolat.x < 230 &&  chocolat.y > 370 && chocolat.x > 100 && chocolat.y < 470){
                       
                       eatfalse()
                       chocolat.setPosition(550, 150);
                   
                   }else{
                       chocolat.setPosition(550, 150);
                   }
                   

               })

       this.seed.setInteractive({ draggable: true })
               this.seed.on('dragstart', function(pointer, dragX, dragY){
                   // ...
               })
               this.seed.on('drag', function(pointer, dragX, dragY){
                   seed.setPosition(dragX, dragY);
                   
               })
               this.seed.on('dragend', function(pointer, dragX, dragY, dropped){
                   if(seed.x < 230 &&  seed.y > 370 && seed.x > 100 && seed.y < 470){
                       
                       eat(seed)
                       seed.setPosition(700, 150);
                   
                   }else{
                       seed.setPosition(700, 150);
                   }
                   
               })

       this.fruits.setInteractive({ draggable: true })
               this.fruits.on('dragstart', function(pointer, dragX, dragY){
                   // ...
               })
               this.fruits.on('drag', function(pointer, dragX, dragY){
                   fruits.setPosition(dragX, dragY);
               })
               this.fruits.on('dragend', function(pointer, dragX, dragY, dropped){
                   if(fruits.x < 230 &&  fruits.y > 370 && fruits.x > 100 && fruits.y < 470){
                       
                       eat(fruits)
                       fruits.setPosition(500, 300);
                   
                   }else{
                       fruits.setPosition(500, 300);
                   }
               })

       this.insect.setInteractive({ draggable: true })
               this.insect.on('dragstart', function(pointer, dragX, dragY){
                   // ...
               })
               this.insect.on('drag', function(pointer, dragX, dragY){
                   insect.setPosition(dragX, dragY);
               })
               this.insect.on('dragend', function(pointer, dragX, dragY, dropped){
                   
                   if(insect.x < 230 &&  insect.y > 370 && insect.x > 100 && insect.y < 470){
                       
                       eat(insect)
                       insect.setPosition(750, 300);
                   
                   }else{
                       insect.setPosition(750, 300);
                   }
                   
               })

       this.honey.setInteractive({ draggable: true })
               this.honey.on('dragstart', function(pointer, dragX, dragY){
                   // ...
               })
               this.honey.on('drag', function(pointer, dragX, dragY){
                   honey.setPosition(dragX, dragY);
               })
               this.honey.on('dragend', function(pointer, dragX, dragY, dropped){
                   if(honey.x < 230 &&  honey.y > 370 && honey.x > 100 && honey.y < 470){
                       
                       eatfalse()
                       honey.setPosition(625, 450);
                   
                   }else{
                       honey.setPosition(625, 450);
                   }   
               })
       let time = this.time        
       let scene = this.scene       
       function eat(food){
            let textStatus = document.querySelector('.eatgame__textstatus--true')
            textStatus.classList.add('eatgame__textstatus--showtrue')
            time.addEvent({
                delay: 500,
                callback: ()=>{
                    textStatus.classList.remove('eatgame__textstatus--showtrue')
                    
                },
                loop: false
            })
           food.setActive(false).setVisible(false);
           foodscore +=1
           console.log(foodscore)
           if(foodscore == 3){
            GameScreen.classList.add('end__game')
            GameScreen.classList.remove('start__game')
            next();
               time.addEvent({
                   delay: 1000,
                   callback: ()=>{
                      
                       scene.stop();
                   },
                   loop: true
               })
           }
       }
       function eatfalse(){
           let textStatus = document.querySelector('.eatgame__textstatus--false')
           textStatus.classList.add('eatgame__textstatus--showfalse')
           time.addEvent({
            delay: 1000,
            callback: ()=>{
               
                textStatus.classList.remove('eatgame__textstatus--showfalse')
            },
            loop: false
        })
           foodscore = 0
           chocolat.setActive(true).setVisible(true);
           seed.setActive(true).setVisible(true);
           fruits.setActive(true).setVisible(true);
           insect.setActive(true).setVisible(true);
           honey.setActive(true).setVisible(true);
           
           console.log(foodscore)
           
           
       }
      
   },
   update: function()
   {   
       
       
       
   },
});

/////////////////// FLYGAME ///////////////////////////
var FlyGame = new Phaser.Class({
   Extends: Phaser.Scene,
   initialize: function FlyGame(config) {
       Phaser.Scene.call(this, config);
     },  
   
   preload: function()
   {
       this.load.image('flysvg', 'assets/images/fly.png');
       this.load.image('hirondell', 'assets/images/hirondell.png');
       this.load.image('frontbg', 'assets/images/frontpng.png');
       this.load.image('midbg', 'assets/images/midpng.png');
       this.load.image('backbg', 'assets/images/backpng.png');

   },
   create: function()
   {
       var hirondell

       this.width = this.scale.width
       this.height = this.scale.height

       this.back = this.add.image(0,this.height,'backbg')
           this.back.setOrigin(0,1)
       this.mid = this.add.image(0,this.height,'midbg')
           this.mid.setOrigin(0,1)
       this.mid2 = this.add.image(this.mid.width,this.height,'midbg')
           this.mid2.setOrigin(0,1) 
       this.front = this.add.image(0,this.height,'frontbg')
           this.front.setOrigin(0,1)
       this.front2 = this.add.image(this.front.width,this.height,'frontbg')
           this.front2.setOrigin(0,1)



           hirondell = this.add.image(100,250,'hirondell')
         this.physics.add.existing(hirondell)
         hirondell.setScale(0.4) 
         hirondell.body.setCollideWorldBounds(true)
         hirondell.body.setCircle(50,350,80)
               
         hirondell.setInteractive({ draggable: true })
         hirondell.on('dragstart', function(pointer, dragX, dragY){
               // ...
         })
         hirondell.on('drag', function(pointer, dragX, dragY){
            hirondell.setPosition(hirondell.x, dragY);
         })
         hirondell.on('dragend', function(pointer, dragX, dragY, dropped){
               // ...
         })
            
         this.fly = this.add.image(1000,Phaser.Math.Between(50,550),'flysvg')
         this.fly.setScale(Phaser.Math.Between(3,4)/20)
         
         this.fly1 = this.add.image(1000,Phaser.Math.Between(50,550),'flysvg')
         this.fly1.setScale(Phaser.Math.Between(3,4)/20)
         
         this.fly2 = this.add.image(1000,Phaser.Math.Between(50,550),'flysvg')
         this.fly2.setScale(Phaser.Math.Between(3,4)/20)
         
         this.fly3 = this.add.image(1000,Phaser.Math.Between(50,550),'flysvg')
         this.fly3.setScale(Phaser.Math.Between(3,4)/20)
         
         this.flys = this.physics.add.group()
         this.flys.add(this.fly)
         this.flys.add(this.fly1)
         this.flys.add(this.fly2)
         this.flys.add(this.fly3)

         this.physics.add.overlap(hirondell, this.flys, eatFly, null, this)

         moveFly(this.fly)
         moveFly(this.fly1)
         moveFly(this.fly2)
         moveFly(this.fly3)

         function moveFly(fly) {
           let speedfly = Phaser.Math.Between(100,350)
           fly.body.setVelocity(-speedfly,0); 
         }
         var score=0;
       
         function eatFly(hirondell, fly) {
         let scoretext = document.querySelector('.flygame__textstatus--text')   
         let speedfly = Phaser.Math.Between(100,350)
         fly.setPosition(1000,Phaser.Math.Between(50,550));
         fly.setScale(Phaser.Math.Between(3,4)/20)
         fly.body.setVelocity(-speedfly,0)
         score++
         scoretext.innerHTML = score+'/20'
         console.log(score)
           
         if(score == 20){
          let scorediv = document.querySelector('.flygame__textstatus')
          scorediv.classList.remove('flygame__textstatus--show')
            GameScreen.classList.add('end__game')
            GameScreen.classList.remove('start__game')
            next();
            this.time.addEvent({
               delay: 1000,
               callback: ()=>{
                  this.scene.stop();
               },
               loop: true
            })
         }
      }
   },
   update: function(){  
      this.front.x -=1.5
      this.front2.x -=1.5
      this.mid.x -=1
      this.mid2.x -=1 

      if(this.front.x == -this.front.width){
         this.front.x = this.front.width
      }
      if(this.front2.x == -this.front.width){
         this.front2.x = this.front.width
      }
      if(this.mid.x == -this.front.width){
         this.mid.x = this.front.width
      }
      if(this.mid2.x == -this.front.width){
         this.mid2.x = this.front. width   
      }
      console.log('fygame running')
      if(this.fly.x < 0){
         let speedfly = Phaser.Math.Between(100,350)
         this.fly.setPosition(1000,Phaser.Math.Between(50,550));
         this.fly.setScale(Phaser.Math.Between(3,4)/20)
         this.fly.body.setVelocity(-speedfly,0)
      }
      if(this.fly1.x < 0){
         let speedfly = Phaser.Math.Between(100,350)
         this.fly1.setPosition(1000,Phaser.Math.Between(50,550));
         this.fly1.setScale(Phaser.Math.Between(3,4)/20)
         this.fly1.body.setVelocity(-speedfly,0)
      }
      if(this.fly2.x < 0){
         let speedfly = Phaser.Math.Between(100,350)
         this.fly2.setPosition(1000,Phaser.Math.Between(50,550));
         this.fly2.setScale(Phaser.Math.Between(3,4)/20)
         this.fly2.body.setVelocity(-speedfly,0)
      }
      if(this.fly3.x < 0){
         
         let speedfly = Phaser.Math.Between(100,350)
         this.fly3.setPosition(1000,Phaser.Math.Between(50,550));
         this.fly3.setScale(Phaser.Math.Between(3,4)/20)
         this.fly3.body.setVelocity(-speedfly,0)
      }
    
   }
});

/////////////////// LOVEGAME///////////////////////////
var LoveGame = new Phaser.Class({
   Extends: Phaser.Scene,
   initialize: function LoveGame(config) {
       Phaser.Scene.call(this, config);
     },  
   
   preload: function()
   {
       this.load.image('moineau', 'assets/images/moineau.png');
       this.load.image('moineau__girl', 'assets/images/moineau_femelle.png');
       this.load.image('branche','assets/images/branche.png')
   },
   create: function()
   {
       this.branche = this.add.image(400,440,'branche')
       this.branche.setScale(0.8)

       this.moineau = this.add.image(600,300,'moineau')     //560 position kiss  830 dead
       this.physics.add.existing(this.moineau)
       this.moineau.setScale(0.4)
        
       this.moineau2 = this.add.image(350,300,'moineau__girl')    //390 position kiss  120 dead
       this.physics.add.existing(this.moineau2)
       this.moineau2.setScale(0.4) 
       this.moineau.flipX = true;
       let moineau2  = this.moineau2
       let moineau  = this.moineau
       let scene = this.scene
       this.zone = this.add.rectangle(0, 0, 960, 600);
       this.zone.setOrigin(0,0)
       
       this.zone.setInteractive().on('pointerdown', function(pointer, localX, localY, event){
           console.log('tap')
           moineau2.x +=10
           moineau.x -=10

           if(moineau.x < 560){
               console.log('Coeur coeur')
               GameScreen.classList.add('end__game')
               GameScreen.classList.remove('start__game')
               next();
               moineau.flipX = false;
               moineau2.flipX = true;
               scene.pause();
               
           }
       });     
   },
   update: function()
   {   
      this.moineau2.x -=0.2
      this.moineau.x +=0.2
      if(this.moineau.x > 830){
       console.log('dead recommence')
       this.scene.pause();
       
   }   
   }
});
///////// LOAD & FUNCTION TO START GAMES/////////////
game.scene.add('lovegame',LoveGame)
game.scene.add('eatgame',EatGame)
game.scene.add('flygame',FlyGame)

const appConsigne = document.querySelectorAll('.app__consigne');
function love(){
   game.scene.start('lovegame')
   GameScreen.classList.remove('end__game')
   GameScreen.classList.add('start__game')

   //div hidden
   appConsigne[2].classList.add('app__consigne--hidden');
}
function fly(){
  let scorediv = document.querySelector('.flygame__textstatus')
  scorediv.classList.add('flygame__textstatus--show')
   game.scene.start('flygame')
   GameScreen.classList.remove('end__game')
   GameScreen.classList.add('start__game')

   //div hidden
   appConsigne[1].classList.add('app__consigne--hidden');
}

function eat(){
   game.scene.start('eatgame')
   GameScreen.classList.remove('end__game')
   GameScreen.classList.add('start__game')

   //div hidden
   appConsigne[0].classList.add('app__consigne--hidden');
}

//Nom

var stockageNom = localStorage.getItem("data-nom");

// var nameValue = document.getElementById('name').value;

var submitButton = document.getElementById('submitButton');
// var result = document.getElementById('result');
// var result2 = document.getElementById('result2');

// if (stockageNom == nameValue){
   
//    result.textContent= nameValue;
//    result2.textContent= nameValue;
// }




// function userNameInput () {
//    var nameValue = document.getElementById('name').value; 
//    localStorage.setItem("data-nom", nameValue);
//    result.textContent= nameValue;
//    result2.textContent= nameValue;
//    next();
// }
// submitButton.addEventListener('click', userNameInput, false);

//start Eatgame
const GameScreen = document.querySelector('.app canvas')
console.log(GameScreen)
GameScreen.classList.add('end__game')
const btnStartgame = document.querySelectorAll('.slider__btn--game')
btnStartgame[0].addEventListener('click',eat)
btnStartgame[1].addEventListener('click',fly)
btnStartgame[2].addEventListener('click',love)
console.log(btnStartgame)



//Animation dialogues

const dialogues = gsap.utils.toArray('.app__dia');
console.log('.app__dia');



function isInViewport(el) {
    const dia = el.getBoundingClientRect();
    return (
        dia.top >= 0 &&
        dia.left >= 0 &&
        dia.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        dia.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function diaAnim(){
    const tl1 = gsap.timeline({});
    tl1.set('.dia0-1',{
        opacity: 1
    });
    tl1.set('.dia0-2',{
        opacity: 0
    });
    tl1.to('.dia0-1',{
        opacity: 0,
        delay: 4
    });
    tl1.to('.dia0-2',{
        opacity: 1
    });
};
function diaAnim1(){
    const tl1 = gsap.timeline({});
    tl1.set('.dia1-1',{
        opacity: 1
    });
    tl1.set('.dia1-2',{
        opacity: 0
    });
    tl1.to('.dia1-1',{
        opacity: 0,
        delay: 4
    });
    tl1.to('.dia1-2',{
        opacity: 1
    });
};
function diaAnim2(){
    const tl2 = gsap.timeline({});
    tl2.set('.dia2-1',{
        opacity: 1
    });
    tl2.set('.dia2-2',{
        opacity: 0
    });
    tl2.set('.dia2-3',{
        opacity: 0
    });
    tl2.set('.dia2-4',{
        opacity: 0
    });
    tl2.to('.dia2-1',{
        opacity: 0,
        delay: 4
    });
    tl2.to('.dia2-2',{
        opacity: 1
    });
    tl2.to('.dia2-2',{
        opacity: 0,
        delay: 4
    });
    tl2.to('.dia2-3',{
        opacity: 1
    });
    tl2.to('.dia2-3',{
        opacity: 0,
        delay: 4
    });
    tl2.to('.dia2-4',{
        opacity: 1
    });
};
function diaAnim3(){
    const tl3 = gsap.timeline({});
    tl3.set('.dia3-1',{
        opacity: 1
    });
    tl3.set('.dia3-2',{
        opacity: 0
    });
    tl3.set('.dia3-3',{
        opacity: 0
    });

    tl3.to('.dia3-1',{
        opacity: 0,
        delay: 2
    });
    tl3.to('.dia3-2',{
        opacity: 1
    });
    tl3.to('.dia3-2',{
        opacity: 0,
        delay: 4
    });   
    tl3.to('.dia3-3',{
        opacity: 1,
    });
};

function diaAnim4(){
    const tl3 = gsap.timeline({});
    tl3.set('.dia4-1',{
        opacity: 1
    });
    tl3.set('.dia4-2',{
        opacity: 0
    });
    tl3.set('.dia4-3',{
        opacity: 0
    });
    tl3.set('.dia4-4',{
        opacity: 0
    });
    tl3.to('.dia4-1',{
        opacity: 0,
        delay: 6
    });
    tl3.to('.dia4-2',{
        opacity: 1
    });
    tl3.to('.dia4-2',{
        opacity: 0,
        delay: 6
    });
    tl3.to('.dia4-3',{
        opacity: 1
    });
    tl3.to('.dia4-3',{
        opacity: 0,
        delay: 6
    });
    tl3.to('.dia4-4',{
        opacity: 1
    });
};

function diaAnim5(){
    const tl2 = gsap.timeline({});
    tl2.set('.dia5-1',{
        opacity: 1
    });
    tl2.set('.dia5-2',{
        opacity: 0
    });
    tl2.set('.dia5-3',{
        opacity: 0
    });
    tl2.set('.dia5-4',{
        opacity: 0
    });
    tl2.to('.dia5-1',{
        opacity: 0,
        delay: 6
    });
    tl2.to('.dia5-2',{
        opacity: 1
    });
    tl2.to('.dia5-2',{
        opacity: 0,
        delay: 6
    });
    tl2.to('.dia5-3',{
        opacity: 1
    });
    tl2.to('.dia5-3',{
        opacity: 0,
        delay: 5
    });
    tl2.to('.dia5-4',{
        opacity: 1
    });
};

dialogues.forEach(dialogue => {
    // const objetDia = dialogue.getBoundingClientRect();
    // console.warn(objetDia);
    if(isInViewport(dialogue) ){
        
    }
    passive: true
});